import { Box, styled } from "@mui/material";

export const StyledCustomerInfoCard = styled(Box)(({ theme }) => ({
  width: "30rem",
  borderRadius: "15px",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  border: `3px solid ${theme.contrast.lighter}`,
  h2: {
    color: theme.color.background,
    background: theme.color.main,
    paddingInline: "2rem",
  },
  ".head": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "svg:hover": {
      color: theme.color.dark,
      cursor: "pointer",
    },
  },
  ".row": {
    height: "1.8rem",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingInline: "2rem",
    h4: {
      color: theme.contrast.main,
      minWidth: "12.5rem",
    },
    ".right": {
      textAlign: "end",
    },
    ".text": {
      width: "5rem",
      minWidth: "0",
    },
  },
}));
